import { useEffect, useRef } from "react";

export function useLatest<T>(value: T) {
  const ref = useRef<T>(value);

  // React team doesn't recommend to change ref during rendering
  // https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref;
}
